import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '4%',
    paddingRight: '4%',
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  content: {
    width: '100%',
    flexDirection: 'row-reverse',
    paddingVertical: 8
  },
  subjectTitle: {
    fontSize: 9,
    color: 'black',
    marginLeft: 4
  },
  subjectValue: {
    fontSize: 8,
    fontWeight: 'bold',
    color: 'black',
    direction: 'rtl',
    textAlign: 'right'
  },
  subject1: {
    width: '60%',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  subject2: {
    width: '40%',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  rowDirection: {
    flexDirection: 'row-reverse'
  },
  refundRow: {
    marginTop: 4
  }
})
export default styles
